
<div>
<app-header></app-header>
</div>

<div class="appcomp-nogutters row">
   <div  class="tabstrip-tab">  
  <kendo-tabstrip 
    tabPosition="left" 
    class="menu-panel"
    (tabSelect)="navigateTabs($event)">
    <kendo-tabstrip-tab [title]="appConstants.HomeLabel"
      [selected]="handleMenuActiveClass(appConstants.AppRoutes.HomePage)">
      <ng-template kendoTabTitle>
        <span class="k-icon k-font-icon k-i-home"></span>&nbsp;
        {{appConstants.HomeLabel}}
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="appConstants.OperationsReportLabel" 
      [selected]="handleMenuActiveClass(appConstants.AppRoutes.OperationsReport)">
      <ng-template kendoTabTitle>
        <span class="k-icon k-font-icon k-i-file-ascx"></span>&nbsp;
        {{appConstants.OperationsReportLabel}}
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="appConstants.OTBookingLabel" 
      [selected]="handleMenuActiveClass(appConstants.AppRoutes.OTBooking)">
      <ng-template kendoTabTitle>
        <span class="k-icon k-font-icon k-i-clock"></span>&nbsp;
        {{appConstants.OTBookingLabel}}
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="appConstants.ESubCheckListLabel" 
      [selected]="handleMenuActiveClass(appConstants.AppRoutes.EsubChecklistComponent)">
      <ng-template kendoTabTitle>
        <span class="k-icon k-font-icon k-i-calendar"></span>&nbsp;
        {{appConstants.ESubCheckListLabel}}
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="appConstants.HolidayManagementLabel" 
      [selected]="handleMenuActiveClass(appConstants.AppRoutes.Holiday)">
      <ng-template kendoTabTitle>
        <span class="k-icon k-font-icon k-i-calendar"></span>&nbsp;
        {{appConstants.HolidayManagementLabel}}
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
<div class="router-position">
    <router-outlet></router-outlet>
  </div>

 
